import { render, staticRenderFns } from "./SettingStreakBonus.vue?vue&type=template&id=51eef79d"
import script from "./SettingStreakBonus.vue?vue&type=script&lang=js"
export * from "./SettingStreakBonus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports